import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Menu from "@mui/material/Menu";
import { MenuItem, Tooltip } from "@mui/material";

export interface StreamCardMenuOption {
  title: string;
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
}

export interface StreamCardMenuProps {
  menuIcon?: React.ReactNode;
  menuOptions: StreamCardMenuOption[];
}

export const StreamCardMenu = ({
  menuIcon = <MoreHorizIcon />,
  menuOptions
}: React.PropsWithChildren<StreamCardMenuProps>): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        onClick={e => setAnchorEl(e.currentTarget)}
        data-qa="CP-Button-More-Options"
        size="large"
      >
        {menuIcon}
      </IconButton>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setAnchorEl(null)}
      >
        {menuOptions.map(menuOption => {
          const item = (
            <MenuItem
              key={menuOption.title}
              onClick={menuOption.onClick}
              disabled={menuOption.disabled}
            >
              {menuOption.title}
            </MenuItem>
          );
          if (menuOption.tooltip) {
            return (
              <Tooltip key={menuOption.title} title={menuOption.tooltip}>
                <span>{item}</span>
              </Tooltip>
            );
          }
          return item;
        })}
      </Menu>
    </>
  );
};
